export default {
  init() {
    // init
  },
  finalize() {
    // Finalize

    jQuery('#pos-controls, #pos-gmap').on("change", function() {
      if(jQuery('#pos-controls').css('display') == 'none' || jQuery('#pos-controls').is(':empty')) {
        jQuery('#pos-controls-container').css('display','none');
      } else {
        jQuery('#pos-controls-container').css('display','block');
      }
    });

    jQuery('.wpsl-geo-button').on('click', function() {
      jQuery('input.address').val('');
    });

    var observer = new MutationObserver(function(mutations, observer) { //eslint-disable-line
      mutations.forEach(function(record) { //eslint-disable-line
        var countDiv = jQuery('.pomelo-wpsl-results').length;
        var distanceselect = jQuery('.distanceselect').val();
        var textResultLocation = PomeloVar.simple_locator_header_result; //eslint-disable-line
        distanceselect
        jQuery('.pomelo-wpsl-results-header').text(textResultLocation.replace('%$1', countDiv)); //eslint-disable-line
        jQuery('#pos-controls').trigger('change');
      });
    });

    observer.observe(window.document.getElementById('pos-controls'), {
      childList: true,      // Être notifié des ajouts/suppressions de noeud
      subtree: false,       // Observer également le subtree
      characterData: true,  // Inclure les changements de contenu
      attribute: false,     // Inclure les changements d'attribut dans le subtree
    });

    jQuery(document).ready(() => {
      jQuery('#pos-controls, #pos-gmap').trigger("change");
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-find-our-products.js